module.exports = __webpack_public_path__ + "static/media/locIcon.f3df654d.svg";